import { type HTMLAttributes, type MouseEventHandler, useEffect, useState } from "react"
import { Switch } from "@/shared/components"
import { MinusIcon } from "@/shared/components/ui/icons"
import { cn } from "@/shared/lib/utils.ts"

type ICustomState = "true" | "false" | "mixed"

interface IProps extends Omit<HTMLAttributes<HTMLButtonElement>, "onChange"> {
  initialState: ICustomState
  onChange?: (value: ICustomState) => void
}

const CustomCheckbox = ({ initialState, onChange, onClick, ...props }: IProps) => {
  const [state, setState] = useState(initialState)

  useEffect(() => {
    setState(initialState)
  }, [initialState])

  const handleChange: MouseEventHandler<HTMLButtonElement> = e => {
    if (onClick) onClick(e)
    const newState = state === "false" ? "true" : "false"
    if (onChange) onChange(newState)
  }

  const renderIcon = (checked: ICustomState) => {
    switch (checked) {
      case "mixed":
        return <MinusIcon size={20} viewBox="0 0 20 20" color="#237AD2" fillOpacity="0.08" />
      case "true":
        return <Switch type="checkbox" checked />
      default:
        return <Switch type="checkbox" checked={false} />
    }
  }

  return (
    <button
      tabIndex={-1}
      type="button"
      onClick={handleChange}
      className={cn("flex h-6 w-6 cursor-pointer items-center justify-center", props.className)}
    >
      {renderIcon(state)}
    </button>
  )
}

export default CustomCheckbox
